import { escapeHtml } from '../../utilities/helper';
import { DEFAULT_THEME } from './bannerMarkup';

/* A store can go Live from Store Profile before its Store designer was ever
   opened, and only opening the designer publishes its seed. Until then the
   published HOME page is null, so the storefront stands in the page the
   designer would publish on first open. Keep in step with the designer's seed
   (retailer portal GrapesEditor `tempAllEditorValues`). */

// Escaped because published html_content arrives entity-encoded and
// StoreBuilder's decodeHtml reads it back through textContent.
const DEFAULT_HTML_CONTENT = escapeHtml(
  '<html><head></head><body>' +
    '<section id="main-banner-container" class="custom-storebuilder-padding md:px-[0px]"></section>' +
    '</body></html>'
);

export const buildDefaultHomePage = (storeDetails) => ({
  html_content: DEFAULT_HTML_CONTENT,
  page_data: {
    announcementBarText: 'Welcome to our new online store — we appreciate your support.',
    announcementBarEnabled: true,
    homeEnabled: true,
    navLinks: [
      { id: 1, label: 'Shop All', link: '/all-products', default: true, enabled: true },
      { id: 2, label: 'Categories', link: '/categories', default: true, enabled: true },
      { id: 3, label: 'Brands', link: '/all-brands', default: true, enabled: true },
      { id: 5, label: 'Collections', link: '/all-collections', default: true, enabled: true },
    ],
    mainBanner: {
      title: storeDetails?.store_name,
      subtitle: 'Discover our curated selection of products',
      includeButton: false,
      eyebrow: '',
      bannerStyle: 'color',
      bannerFill: 'block',
      bannerImage: null,
      buttonText: '',
      buttonLink: '',
      secondaryButtonText: '',
      secondaryButtonLink: '',
      trustBadges: [],
      videoUrl: '',
      contentAlignHorizontal: 'center',
    },
    banners: [],
    featuredCollections: [],
    collectionSpotlights: [],
    featuredBrands: [],
    featuredProducts: [],
    textBlocks: [],
    imageWithTextBlocks: [],
    linkLists: [],
    promos: [],
    componentOrder: [],
    logoIdentity: {
      storeLogo: null,
      profilePhoto: null,
      favicon: null,
    },
    colorAndApperances: {
      colorTheme: DEFAULT_THEME,
      custom: false,
      font: 'Inter',
    },
    socialLinks: {
      message: '',
      street: '',
      city: '',
      state: '',
      zip: '',
      phone: '',
      email: '',
      website: '',
      facebook: '',
      instagram: '',
      tiktok: '',
      youtube: '',
      animalList: '',
    },
  },
});

export default buildDefaultHomePage;
